// extracted by mini-css-extract-plugin
export default {"avatarStack":"AssigneesMetadata-module__avatarStack--wphoi","avatar":"AssigneesMetadata-module__avatar--Ythxm"};